import { render, staticRenderFns } from "./ButtonField.vue?vue&type=template&id=47f2abf4"
import script from "./ButtonField.vue?vue&type=script&lang=js"
export * from "./ButtonField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports